import script from "./CustomCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomCard.vue?vue&type=script&lang=ts&setup=true"

import "./CustomCard.vue?vue&type=style&index=0&id=ad480e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad480e7c"]])

export default __exports__